<script setup lang="ts">
import { defineEmits, defineProps } from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";

const props = defineProps<{
  arrowDirection: "left" | "right" | "up" | "down";
}>();

defineEmits(["clicked"]);
</script>

<template>
  <button
    class="size-8 md:size-[34px] flex items-center justify-center rounded-full bg-brown hover:bg-active"
    @click="$emit('clicked')"
  >
    <ArrowIcon
      class="text-white"
      :class="{
        '-rotate-[135deg]': props.arrowDirection === 'left',
        'rotate-[135deg]': props.arrowDirection === 'down',
        '-rotate-[45deg]': props.arrowDirection === 'up',
        'rotate-[45deg]': props.arrowDirection === 'right',
      }"
    />
  </button>
</template>
